import { createHead } from '@unhead/vue';

export const head = createHead();
